import React, {useEffect, useState} from 'react';
import './Games.sass';

import * as Cookie from 'js-cookie';

// import {FormattedMessage} from 'react-intl';

import {taxonNestedSet} from '../../utils/taxons';

import ChannelImage from '../../containers/channelUtils/ChannelImage';
// import ChannelLink from '../../containers/channelUtils/ChannelLink';

import Loader from '../loader/Loader';
// import Button from '../button/Button';
import RawHtml from '../rawHtml/RawHtml';
import {Link} from "react-router";

function Game({ name, description, image, slug, intl, subcategories }) {
  return (
    <Link to={`/${slug}`} className="game" onlyActiveOnIndex={false}>
      <div className='game__background'>
        <ChannelImage loading="lazy" src={image} alt={`${name} - ${intl.formatMessage({ id: 'page.common.image' })}`}/>
      </div>
      <div className="game__content">
        <div className="game__header">{name}</div>
        <RawHtml className="game__text" content={description}/>
        {/* <div className="game__btns">
          <div className="game__btn  game__btn--main">
            <Button component={ChannelLink} to={`/${slug}`} extraSmall>
              <FormattedMessage id="section.games.show"/>
            </Button>
          </div>

          {subcategories && subcategories.map(subcategory => (
           <div
             key={subcategory.code}
             className="game__btn"
           >
             <Button component={ChannelLink} to={`/${subcategory.slug}`} extraSmall>
               {subcategory.name}
             </Button>
           </div>
          ))}
        </div> */}
      </div>
    </Link>
  );
}

export default function Games({ categories, intl }) {
  const [categoryTree, setCategoryTree] = useState(null);

  useEffect(() => {
    if (categories) {
      let categoryTree = taxonNestedSet.nest(categories);

      if (Cookie.get('blacklist')) {
        const excludedTaxons = JSON.parse(Cookie.get('blacklist'));

        categoryTree =
          categoryTree && categoryTree.filter(({ slug }) => !excludedTaxons.includes(slug));

        setCategoryTree(categoryTree);
      } else {
        setCategoryTree(categoryTree);
      }
    }
  }, [categories]);

  if (!categories || !categoryTree) {
    return <Loader section />;
  }

  return (
    <div className="games">
      <div className="games__row">
        {categoryTree.map((category) => (
          <div
            key={category.code}
            className="games__item"
          >
            <Game
              name={category.name}
              description={category.shortDescription}
              image={category.images.find(it => it.type === 'main') || false}
              slug={category.slug}
              intl={intl}
              subcategories={category.children ? category.children.filter(it => !it.homepageHidden) : []}
            />
            </div>
        ))}
      </div>
    </div>
  );
}




// WEBPACK FOOTER //
// ./components/games/Games.js